import { Col, Row, TextLabel } from "../lib";
import { formatTime } from "../services";
import { createStyles } from "../theme";
import { ChatBubble } from "./chat-bubble";

type Props = {
  date: Date;
  self?: boolean;
  read?: boolean;
  text: string;
};

export function ChatMessage({ text, read = false, self = false, date }: Props) {
  return (
    <Row.BL mt="2" style={self && $.reverse}>
      <ChatBubble {...{ self, text }} />
      <Col.BR>
        {self && read && <TextLabel>Read</TextLabel>}
        <TextLabel>{formatTime(date)}</TextLabel>
      </Col.BR>
    </Row.BL>
  );
}

const $ = createStyles({
  reverse: {
    flexDirection: "row-reverse",
  },
});
